// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__60bMw","range":"MonthRangeSwitch_range__rzkAh","disabled":"MonthRangeSwitch_disabled__2vYLC"};